var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamatoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.992,
    cy: 10,
    fill: "#F5B605",
    rx: 9.992,
    ry: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFE",
    fillOpacity: 0.988,
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 15.988 3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.995,
    cy: 11.5,
    rx: 1.499,
    ry: 1.5,
    transform: "rotate(180 5.995 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.744 7.75H5.245v-7h1.499z"
  })))));
}
export default SvgExclamatoryIcon;